module.exports = {
    'uaa.version': 'Versione di UAA:',
    'uaa.menu.profile': 'Profilo',
    'uaa.menu.administration': 'Amministrazione',
    'uaa.menu.users': 'Utenti',
    'uaa.menu.roles': 'Ruoli',
    'uaa.menu.groups': 'Gruppi',
    'uaa.menu.companies': 'Distretti',
    'uaa.menu.templates': 'Template',
    'uaa.menu.audit': 'Audit',

    'uaa.no_data': 'Nessun dato da visualizzare.',
    'uaa.handles-403-loop.title':'Oops! Si è verificato un errore.',
    'uaa.handles-403-loop.msg':'Questa pagina non può caricare la Home correttamente. Apri la console JavaScript per i dettagli tecnici.',
    'uaa.handles-403-loop.detail': 'Loop nel reindirizzamento a seguito dell\'errore 403: l\'utente non possiede alcuni permessi per visualizzare la index page, oppure si sta cercando di aprire la stessa pagina senza avere i permessi.',
    
    "core.notify_info": "Info!",
    "core.notify_error": "Errore!",
    "core_notify_perms.denied": "Non possiedi i permessi necessari.",

    "jdro_common.error_401": "Non Autenticato o sessione scaduta (401)",
    "jdro_common.error_403": "Non Autorizzato (403)",
    "jdro_common.edit": "Modifica",
    'jdro_common.action': 'Azioni',
    "jdro_common.not_set_ms": "Non specificato",
    "jdro_common.not_set_fm": "Non specificata",
    "jdro_common.not_set_more": "Non specificati",
    "jdro_common.find": "Ricerca..",
    "jdro_common.delete": "Elimina",
    "jdro_common.cancel": "Cancella",
    "jdro_common.retry": "Torna Indietro",
    "jdro_common.save": "Salva",
    "jdro_common.multiSelect.selectAll": "Seleziona Tutto",
    "jdro_common.multiSelect.selectNone": "Deseleziona Tutto",
    "jdro_common.multiSelect.reset": "Reset",
    "jdro_common.multiSelect.search": "Scrivi qui per cercare...",
    "jdro_common.multiSelect.nothingSelected": "Nessun elemento selezionato",

    "jdro_person.notify_409_error": "Impossibile creare l'utente poichè l'email è già in uso. Provare con un'altra email.",
    "jdro_person.list": "Lista Utenti",
    "jdro_person.add": "Aggiungi Utente",
    "jdro_person.add_message": "Definisci una nuova persona",
    "jdro_person.username": "Username",
    "jdro_person.activated": "Attivato",
    "jdro_person.enabled": "Abilitato",
    "jdro_person.name": "Nome",
    "jdro_person.surname": "Cognome",
    "jdro_person.email": "E-Mail",
    "jdro_person.company": "Distretto di appartenenza",
    "jdro_person.roles": "Ruoli dell'utente",
    "jdro_person.group": "Gruppi dell'utente",
    "jdro_person.password": "Password",
    "jdro_person.confirm_password": "Conferma Nuova Password",
    "jdro_person.identity": "Identità",
    "jdro_person.information_user": "Informazioni dell'utente",
    "jdro_person.activated_user": "Se desideri che questa persona abbia accesso al sistema questo box deve essere spuntato. Altrimenti può non essere selezionato.",
    "jdro_person.new_password": "Nuova Password",
    "jdro_person.confirm_new_password": "Conferma Nuova Password",
    "jdro_person.old_password": "Vecchia Password",
    "jdro_person.confirm_old_password": "Conferma Vecchia Password",
    "jdro_person.thumb": "Immagine profilo",
    "jdro_person.sourceimage": "Immagine Sorgente",
    "jdro_person.sourceimage_error": "Tipo di file non supportato!",
    "jdro_person.sourceimage_preview": "Anteprima",
    "jdro_person.sourceimage_cropme": "Area di selezione",
    "jdro_person.placeholder.username": "Digita l'username dell'utente",
    "jdro_person.placeholder.name": "Inserisci il nome dell'utente",
    "jdro_person.placeholder.surname": "Inserisci il cognome dell'utente",
    "jdro_person.placeholder.email": "Inserisci l'email dell'utente",
    "jdro_person.placeholder.company": "Seleziona il distretto di competenza dell'utente",
    "jdro_person.placeholder.group": "Gruppo di appartenenza dell'utente",
    "jdro_person.placeholder.password": "Digita la password",
    "jdro_person.placeholder.old_password": "Digita la password precedente",
    "jdro_person.placeholder.new_password": "Digita la nuova password",
    "jdro_person.placeholder.confirm_new_password": "Conferma la nuova password",
    "jdro_person.placeholder.confirm_password": "Digita di nuovo la password",
    "jdro_person.notify_add": "Esito Inserimento Utente",
    "jdro_person.notify_update": "Esito Aggiornamento Utente",
    "jdro_person.confirm_delete": "Conferma Eliminazione Utente",
    "jdro_person.confirm_delete_this_user": "questo account",
    "jdro_person.notify_delete": "Esito Cancellazione Utente",
    "jdro_person.notify_delete_message_success": "L'utente desiderato è stato eliminato con successo!",
    "jdro_person.notify_delete_message_fail": "L'utente non è stato eliminato, si è verificato un errore!",
    "jdro_person.stop_paging": "Hai caricato tutti gli utenti.",
    "jdro_person.button.modify_password": "Modifica password",
    "jdro_person.button.not_modify_password": "Non modificare la password",
    "jdro_person.validate.company": "E' necessario selezionare un'azienda di appartenenza!",
    "jdro_person.validate.role": "E' necessario selezionare almeno un ruolo per l'utente!",
    "jdro_person.validate.email": "L'email inserita è scorretta, si prega di digitare un'email corretta!",
    "jdro_person.validate.identity": "L'username deve essere compresa tra 6 e 50 caratteri!",
    "jdro_person.validate.firstName": "Il campo nome è obbligatorio!",
    "jdro_person.validate.lastName": "Il campo cognome è obbligatorio!",
    "jdro_person.validate.email_required": "Il campo email è obbligatorio!",
    "jdro_person.validate.email_invalid": "La mail inserita non è corretta!",
    "jdro_person.validate_identity.identity_required": "E' necessario specificare la username!",
    "jdro_person.validate_identity.identity_max_length": "La username non può essere più lunga di 50 caratteri!",
    "jdro_person.validate_identity.roles_required": "E' necessario specificare almeno un ruolo per l'utente!",
    "jdro_person.validate_identity.old_password_validate": "Attenzione le vecchie password digitate non matchano tra loro!",
    "jdro_person.validate_identity.new_password_validate": "Attenzione le nuove password digitate non matchano tra loro!",
    "jdro_person.validate_identity.new_password_length_validate": "Attenzione la password deve contenere almeno 6 caratteri!",
    "jdro_person.validate_identity.exist_identity": "L'username inserita appartiene già ad un'altra identità!",
    "jdro_person.validate_identity.old_password_valid": "Attenzione il campo vecchia password non coincide con la password attuale!",
    "jdro_person.validate_identity.old_password_required": "Attenzione occorrre specificare la vecchia password!",
    "jdro_person.validate_identity.password_validate": "Attenzione le password non corrispondono!",
    "jdro_person.error.find_all": "Impossibile scaricare la lista degli utenti!",
    "jdro_profile.tab_one": "Anagrafica Utente",
    "jdro_profile.tab_two": "Modifica Password",
    "jdro_profile.tab_three": "Modifica Immagine",

    "jdro_role.list": "Lista Ruoli",
    "jdro_role.add": "Aggiungi Ruolo",
    "jdro_role.add_message": "Definisci un nuovo ruolo",
    "jdro_role.name_role": "Nome Ruolo",
    "jdro_role.code_role": "Codice Ruolo",
    "jdro_role.placeholder.name_role": "Digita il nome del ruolo",
    "jdro_role.placeholder.code_role": "Digita il codice del ruolo",
    "jdro_role.notify_add": "Esito Inserimento Ruolo",
    "jdro_role.notify_update": "Esito Aggiornamento Ruolo",
    "jdro_role.confirm_delete": "Conferma Eliminazione Ruolo",
    "jdro_role.notify_delete": "Esito Cancellazione Ruolo",
    "jdro_role.notify_delete_message_success": "Il ruolo desiderato è stato eliminato con successo!",
    "jdro_role.notify_delete_message_fail": "Il ruolo non è stato eliminato, si è verificato un errore!",
    "jdro_role.notify.exist_role_code": " non può essere inserito perchè è già presente un ruolo con lo stesso codice!",
    "jdro_role.notify_update.exist_role_code": " non è stato aggiornato perchè è già presente un ruolo con lo stesso codice!",
    "jdro_role.notify_error_get.perms": "Impossibile trovare il ruolo",
    "jdro_role.notify_error_get.role": "Impossibile trovare i permessi",
    "jdro_role.error_name_message": "Il nome del ruolo deve avere una lunghezza superiore ai due caratteri!",
    "jdro_role.error_code_pattern": "Il nome del ruolo può contenere solo caratteri maiuscoli, cifre e il simbolo underscore.",
    "jdro_role.error_code_message": "Il codice del ruolo deve avere una lunghezza superiore ai due caratteri!",
    "jdro_role.error_name_required": "E' necessario specificare il nome del ruolo!",
    "jdro_role.error_code_required": "E' necessario specificare il codice del ruolo!",
    "jdro_role.perms.IDENTITY": "Identity",
    "jdro_role.perms.ADMIN": "Amministratore",
    "jdro_role.perms.CREATE": "Creazione",
    "jdro_role.perms.READ": "Lettura",
    "jdro_role.perms.UPDATE": "Modifica",
    "jdro_role.perms.DELETE": "Cancellazione",
    "jdro_role.perms.ASSESSMENT": "Valutazione prenotazione",
    "jdro_role.perms.ASSESSMENT_CAR": "Valutazione viaggio",
    "jdro_role.perms.AUDIT": "Audit",
    "jdro_role.perms.BOOKABLE_RESOURCE": "Risorsa Stanza",
    "jdro_role.perms.BOOKABLE_RESOURCE_CAR": "Risorsa Auto",
    "jdro_role.perms.BOOKABLE_RESOURCE_DESK": "Risorsa Scrivania",
    "jdro_role.perms.COMPANY_DISTRICT": "Distretti",
    "jdro_role.perms.GROUP": "Gruppi",
    "jdro_role.perms.PERSON": "Utenti",
    "jdro_role.perms.REPORT": "Reports",
    "jdro_role.perms.RESOURCE_OPTION": "Opzioni",
    "jdro_role.perms.RESOURCE_OPTION_TYPE": "Tipi",
    "jdro_role.perms.ROLE": "Ruoli",
    "jdro_role.perms.ROLE_PERMISSION": "Permessi sui ruoli",
    "jdro_role.perms.SCHEDULE": "Prenotazioni",
    "jdro_role.perms.TEMPLATE": "Template",
    "jdro_role.perms.VOTE": "Valutazione",
    "jdro_role.perms.START": "Apertura/Chiusura",
    "jdro_role.perms.MULTI_SCHEDULE": "Stanze Multiple",
    "jdro_role.perms.RESOURCE_OPTION_SCHEDULE": "Prenotazioni Opzioni",
    "jdro_role.error.find_all": "Impossibile scaricare la lista dei ruoli!",

    "jdro_company.list": "Lista Distretti",
    "jdro_company.modal.title": "Informazioni sul distretto",
    "jdro_company.add": "Aggiungi Distretto",
    "jdro_company.tab_one": "Distretto",
    "jdro_company.tab_two": "Utenti",
    "jdro_company.tab_two.user": "Utente",
    "jdro_company.tab_two.email": "Email",
    "jdro_company.tab_two.company": "Distretto",
    "jdro_company.tab_two.group": "Gruppi",
    "jdro_company.tab_two.identity": "Accesso",
    "jdro_company.tab_two.role": "Ruolo",
    "jdro_company.tab_two.role_none": "Nessuno",
    "jdro_company.tab_three": "Devices",
    "jdro_company.tab_three.device": "Serial Number",
    "jdro_company.tab_three.company": "Distretto di appartenenza",
    "jdro_company.tab_three.type": "Tipo di device",
    "jdro_company.tab_three.approved": "Approvato",
    "jdro_company.tab_three.monitored": "Monitorato",
    "jdro_company.nobody_kiosks": "Attenzione questo distretto non possiede alcun device.",
    "jdro_company.nobody_persons": "Attenzione questo distretto non possiede alcun utente.",
    "jdro_company.add_message": "Definisci un nuovo distretto",
    "jdro_company.name_company": "Nome Distretto Aziendale",
    "jdro_company.description_company": "Descrizione del distretto aziendale",
    "jdro_company.father": "Distretto padre",
    "jdro_company.notify_add_suc": "Aggiungi Distretto",
    "jdro_company.district": "Distretti",
    "jdro_company.kiosks": "Devices",
    "jdro_company.placeholder.name": "Inserisci il nome del distretto",
    "jdro_company.placeholder.description": "Inserisci la descrizione del distretto",
    "jdro_company.confirm_delete": "Conferma Eliminazione Distretto",
    "jdro_company.notify_delete": "Esito Cancellazione Distretto",
    "jdro_company.notify_delete_message_success": "Il distretto desiderato è stato eliminato con successo.",
    "jdro_company.notify_delete_message_fail": "Il distretto desiderato, non è stato eliminato. Si è verificato un errore!",
    "jdro_company.notify_add": "Esito Inserimento Distretto",
    "jdro_company.notify_update": "Esito Aggiornamento Distretto",
    "jdro_company.company_of": "Distretto di",
    "jdro_company.placeholder.name_company": "Nome del distretto",
    "jdro_company.validate.name.min_length": "Il nome del distretto deve avere una lunghezza superiore ai due caratteri!",
    "jdro_company.validate.name": "Attenzione occorre specificare il nome del distretto!",
    "jdro_company.error.find_all": "Impossibile scaricare la lista dei distretti!",

    "jdro_group.list": "Lista Gruppi",
    "jdro_group.add": "Aggiungi Gruppo",
    "jdro_group.add_message": "Definisci un nuovo gruppo",
    "jdro_group.name_group": "Nome Gruppo",
    "jdro_group.placeholder.name_group": "Inserisci nome del gruppo",
    "jdro_group.notify_add": "Esito Inserimento Gruppo",
    "jdro_group.notify_update": "Esito Aggiornamento Gruppo",
    "jdro_group.confirm_delete": "Conferma Eliminazione Gruppo",
    "jdro_group.notify_delete": "Esito Cancellazione Gruppo",
    "jdro_group.notify_delete_message_success": "Il gruppo desiderato è stato eliminato con successo!",
    "jdro_group.notify_delete_message_fail": "Il gruppo non è stato eliminato, si è verificato un errore!",
    "jdro_group.error_title_message": "Il nome del gruppo deve avere una lunghezza superiore ai due caratteri!",
    "jdro_group.error.find_all": "Impossibile scaricare la lista dei gruppi!",

    "jdro_audit.info.title": "Audits",
    "jdro_audit.list": "Lista Audits",
    "jdro_audit.modal.title": "Informazioni di controllo",
    "jdro_audit.level": "Livello",
    "jdro_audit.data": "Data",
    "jdro_audit.category": "Categoria",
    "jdro_audit.user": "Utente",
    "jdro_audit.message": "Messaggio",
    "jdro_audit.ip": "IP",
    "jdro_audit.stop_paging": "Hai caricato tutti gli audit.",
    "jdro_audit.error.find_all": "Impossibile scaricare gli audit.",
    "jdro_template.list": "Lista Template",
    "jdro_template.add": "Aggiungi template",
    "jdro_template.back_to_list": "Torna Indietro alla lista dei template",
    "jdro_template.add_message": "Definisci un nuovo template",
    "jdro_template.code": "Codice del template",
    "jdro_template.type": "Tipo di template",
    "jdro_template.from": "Mittente",
    "jdro_template.subject": "Oggetto",
    "jdro_template.content": "Contenuto",
    "jdro_template.placeholder.code": "Inserisci il codice del template",
    "jdro_template.placeholder.type": "Inserisci il tipo di template",
    "jdro_template.placeholder.from": "Inserisci il mittente del template",
    "jdro_template.placeholder.subject": "Inserisci l'oggetto del template",
    "jdro_template.placeholder.content": "Inserisci il contenuto del template",
    "jdro_template.information_template": "Informazioni sul template",
    "jdro_template.confirm_delete": "Conferma Eliminazione Template",
    "jdro_template.notify_delete": "Esito Cancellazione Template",
    "jdro_template.notify_delete_message_success": "Il template desiderato è stato eliminato con successo.",
    "jdro_template.notify_delete_message_fail": "Il template desiderato, non è stato eliminato. Si è verificato un errore!",
    "jdro_template.notify_add": "Esito inserimento template",
    "jdro_template.notify_update": "Esito aggiornamento template",
    "jdro_template.notify.exist_code": "Attenzione esiste già un template con questo codice!",
    "jdro_template.validate.email_required": "Il campo email è obbligatorio!",
    "jdro_template.validate.emailjdro_invalid": "La mail inserita non è corretta!",
    "jdro_template.validate.type": "Il tipo inserito non è consentito!",
    "jdro_template.validate.code": "Il codice inserito non è consentito!",
    "jdro_template.validate.subject": "Attenzione è necessario specificare l'ogetto dell'e-mail!",
    "jdro_template.error.find_all": "Impossibile scaricare la lista dei template!",

    'jdro_role.perms.CONCOURSE_CONFIG': 'Config concorsi',
    'jdro_role.perms.CONCOURSE_EXEC': 'Exec concorsi'

};


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/languages/it.js
// module id = 351
// module chunks = 0